<template>
  <a-form
    ref="formRef"
    :model="formState"
    :rules="rules"
    :label-col="{
      span: 7,
    }"
    :wrapper-col="{
      span: 13,
    }"
  >
    <a-form-item ref="name" label="角色名" name="name">
      <a-input v-model:value="formState.name" />
    </a-form-item>
    <a-form-item ref="code" label="唯一编码" name="code">
      <a-input v-model:value="formState.code" placeholder="不能超过30个字符" />
    </a-form-item>
    <a-form-item label="状态" name="status" v-if="props.isEdit">
      <a-radio-group v-model:value="formState.status">
        <a-radio-button :value="1">启用</a-radio-button>
        <a-radio-button :value="0">禁用</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item label="备注" name="remark">
      <a-input
        v-model:value="formState.remark"
        placeholder="不能超过80个文字"
      />
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" @click="onSubmit">提交</a-button>
      <a-button style="margin-left: 10px" @click="resetForm">重置</a-button>
    </a-form-item>
  </a-form>
</template>
<script setup>
  import { reactive, ref, toRaw, defineProps, defineEmits } from 'vue'
  import { message } from 'ant-design-vue'
  import { createRole, updateRole } from '@/api/system_manage/role'

  const props = defineProps({ isEdit: Boolean, editData: Object })
  const emit = defineEmits(['submit'])
  const formRef = ref()

  const defaultFormState = props.isEdit
    ? {
        roleId: props.editData.role_id,
        name: props.editData.name,
        code: props.editData.code,
        remark: props.editData.remark,
        status: props.editData.status,
      }
    : {
        name: '',
        code: '',
        remark: '',
      }
  const formState = reactive(defaultFormState)
  const rules = {
    name: [
      {
        required: true,
        message: '请输入角色名',
        trigger: 'change',
      },
      {
        min: 1,
        max: 30,
        message: '不能超过30个文字',
        trigger: 'blur',
      },
    ],
    code: [
      {
        required: true,
        message: '请输入唯一编码',
        trigger: 'blur',
      },
      {
        min: 1,
        max: 30,
        message: '不能超过30个字符',
        trigger: 'blur',
      },
      {
        pattern: /^[0-9a-zA-Z:_]+$/,
        message: '仅限阿拉伯数字、英文字母',
        trigger: 'blur',
      },
    ],
  }
  async function handelCreate(data) {
    const ajaxFn = props.isEdit ? updateRole : createRole
    const messageText = props.isEdit ? '编辑' : '创建'
    const res = await ajaxFn(data)
    if (res.success) {
      message.success(messageText + '角色成功！')
      emit('submit')
    } else {
      message.warn(messageText + '角色错误：', res.message)
    }
  }
  function onSubmit() {
    formRef.value
      .validate()
      .then(() => {
        handelCreate(toRaw(formState))
      })
      .catch((error) => {
        console.log('创建角色错误：', error)
      })
  }
  function resetForm() {
    formRef.value.resetFields()
  }
</script>
